import { Handshake, Layers, Compass } from "lucide-react";
import { Reveal } from "./Reveal";

const Overline = ({ children, num }) => (
  <div className="flex items-center gap-4 mb-5">
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">{num}</span>
    <span className="h-px w-10 bg-white/20" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">{children}</span>
  </div>
);

const PILLARS = [
  { icon: Handshake, title: "Partner-Forward", desc: "Built to support prime contractors, OEMs, distributors, and specialty service providers." },
  { icon: Compass, title: "Brand-Neutral Sourcing", desc: "Solutions selected around agency requirements, compatibility, lead time, and best value." },
  { icon: Layers, title: "Scalable Execution", desc: "From single-item purchases to recurring supply and integrated, multi-category requirements." },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Overline num="03">About Atlas</Overline>
            <h2 className="font-sans font-black uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl text-white leading-[0.95]">
              An Emerging Contractor Built On Discipline
            </h2>
            <p className="mt-6 font-body text-neutral-400 text-base md:text-lg leading-relaxed">
              Atlas Contracting Group LLC is a Veteran-Owned Small Business supplying mission-relevant products and
              support services to federal customers. We execute through disciplined sourcing, subcontracting, and
              strategic teaming with qualified manufacturers, distributors, trainers, and technical partners.
            </p>
            <p className="mt-4 font-body text-neutral-400 text-base leading-relaxed">
              Our long-term objective is to grow into a trusted prime contractor capable of coordinating complete
              product and service solutions — serving as the accountable point between the government customer and
              qualified industry partners.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {PILLARS.map((p, i) => {
              const Pi = p.icon;
              return (
                <Reveal key={p.title} delay={i * 0.12} className="flex">
                <div data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s/g, "-")}`} className="w-full border border-white/10 bg-[#121212] p-7 hover:border-white/40 transition-all">
                  <Pi size={30} strokeWidth={1.5} className="text-white mb-5" />
                  <h3 className="font-sans font-bold uppercase tracking-tight text-xl text-white leading-tight">{p.title}</h3>
                  <p className="mt-3 font-body text-neutral-400 text-sm leading-relaxed">{p.desc}</p>
                </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
